export default __webpack_public_path__ + "static/media/b4.a90e6671.png";